export var QuickFilters;
(function (QuickFilters) {
    QuickFilters["lastHour"] = "Last Hour";
    QuickFilters["last4Hours"] = "Last 4 Hours";
    QuickFilters["last12Hours"] = "Last 12 Hours";
    QuickFilters["today"] = "Today";
    QuickFilters["last24Hours"] = "Last 24 Hours";
    QuickFilters["last7Days"] = "Last 7 Days";
    QuickFilters["last30Days"] = "Last 30 Days";
})(QuickFilters || (QuickFilters = {}));
